





































































import Vue from "vue";
// TODO : eslintでno-unused-varsのwarningが出ているので、Vue3へのアップデート時に対応検討する
import InvestmentOptionPanel, { InvestmentOptionPanelType } from "@components/partials/public/projects/InvestmentOptionPanel.vue";
import { ProjectType } from "@components/partials/public/projects/InvestmentOptionSelectBtn.vue";

type DataType = {
  investmentOptionPanels: Array<InvestmentOptionPanelType>,
  project: ProjectType,
  investableNumberOfStocksWithoutConsideringRemainingSlots: number,
  limitNumberOfStocks: number,
  investedNumberOfStocks: number,
  numberOfStocks: number,
  options: Record<string, unknown>
}

export default Vue.extend({
  components: {
    InvestmentOptionPanel
  },
  props: {
    investmentOptionPanelsJsonString: {
      type: String,
      required: true,
    },
    projectJsonString: {
      type: String,
      required: true,
    },
    investableNumberOfStocksWithoutConsideringRemainingSlotsString: {
      type: String,
      required: true,
    },
    limitNumberOfStocksString: {
      type: String,
      required: true,
    },
    investedNumberOfStocksString: {
      type: String,
      required: true,
    },
  },
  data(): DataType {
    const investmentOptionPanels = JSON.parse(this.investmentOptionPanelsJsonString);
    const project = JSON.parse(this.projectJsonString);
    const investableNumberOfStocksWithoutConsideringRemainingSlots = JSON.parse(this.investableNumberOfStocksWithoutConsideringRemainingSlotsString);
    const limitNumberOfStocks = JSON.parse(this.limitNumberOfStocksString);
    const investedNumberOfStocks = JSON.parse(this.investedNumberOfStocksString);
    const numberOfStocks = 0;
    return {
      investmentOptionPanels,
      project,
      investableNumberOfStocksWithoutConsideringRemainingSlots,
      limitNumberOfStocks,
      investedNumberOfStocks,
      numberOfStocks,
      options: {
        width: "90%",
        maxWidth: 600,
        height: "auto",
      }
    };
  },
  computed: {
    amount(): number {
      return this.project.stockIssueAmount  * this.numberOfStocks
    },
    investmentPath(): string {
      return `/projects/${this.project.id}/investments?number_of_stocks=${this.numberOfStocks}`
    },
    addableNumberOfStocks(): number {
      // 投資上限までの株数 or 残り株数のどちらか小さい方 - 選択株数 が追加可能な株数
      return Math.min(this.investableNumberOfStocksWithoutConsideringRemainingSlots, this.project.remainingNumberOfStocks) - this.numberOfStocks
    },
    addableAmount(): number {
      return this.project.stockIssueAmount * this.addableNumberOfStocks
    },
    numberOfStocksSelected(): boolean {
      return this.numberOfStocks > 0
    }
  },
  methods: {
    modalShow(): void {
      this.$modal.show('investmentOptionWithPanelSelectModal');
    },
    addNumberOfStoks(num: number): void {
      if(this.addableNumberOfStocks < num) { return }

      this.numberOfStocks += num
    },
    clearNumberOfStoks(): void {
      this.numberOfStocks = 0
    }
  }
});
